import {toast, ToastOptions} from "react-toastify";

const _defaultOptions: ToastOptions<any> = {
    position: 'bottom-center',
};

export function error(message = 'Ocorreu um erro inesperado.', options: ToastOptions = {}) {
    toast.error(<div dangerouslySetInnerHTML={{__html: message}}/>, {..._defaultOptions, ...options});
}

export function success(message = 'Ação concluida!', options = {}) {
    toast.success(<div dangerouslySetInnerHTML={{__html: message}}/>, {..._defaultOptions, ...options});
}

export default {error, success};